<app-page title="Licenses">
  <div actionButtons class="flex align-items-center flex-1">
    <div class="flex align-items-center gap-2 p-2 surface-ground border-round ml-6 mr-auto">
      <span class="text-sm font-medium text-color-secondary">Quick Filters:</span>
      <div class="flex gap-2">
        <button
          type="button"
          class="quick-filter-btn"
          [class.active]="inProgressFilter()"
          (click)="filterRenewalStatus('In Progress')"
          pTooltip="Licenses with renewal in progress"
          tooltipPosition="top">
          <fa-icon [icon]="['fas', 'spinner']" class="mr-1"></fa-icon>
          In Progress
        </button>
        <button
          type="button"
          class="quick-filter-btn"
          [class.active]="certificateReadyFilter()"
          (click)="filterRenewalStatus('Certificate Ready')"
          pTooltip="Licenses with certificates ready or sent"
          tooltipPosition="top">
          <fa-icon [icon]="['fas', 'file']" class="mr-1"></fa-icon>
          Certificate Ready
        </button>
      </div>
      @if (inProgressFilter() || certificateReadyFilter()) {
        <button
          type="button"
          class="clear-filter-btn"
          (click)="clearRenewalFilters()"
          pTooltip="Clear renewal filters"
          tooltipPosition="top">
          <fa-icon [icon]="['fas', 'times']" size="sm"></fa-icon>
        </button>
      }
    </div>
    <p-button
      (onClick)="resetTableState()"
      severity="secondary"
      pTooltip="Reset filters"
      tooltipPosition="top"
      [text]="true"
      data-testid="reset-all-filters">
      <fa-icon [icon]="['fas', 'rotate-left']" size="lg" transform="rotate-90"></fa-icon>
    </p-button>
    @if (hasVisibleActions()) {
      <app-actions-menu
        [items]="actionsMenuItems()"
        tooltip="Actions"
        tooltipPosition="top"
        testId="licenses-actions-menu"
        class="ml-2">
      </app-actions-menu>
    }
  </div>
  @if (initialGridState) {
    <ag-grid-angular
      class="ag-theme-quartz ag-grid-table"
      [initialState]="initialGridState"
      [gridOptions]="gridOptions"
      [columnDefs]="colDefs"
      [rowSelection]="rowSelection"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      (stateUpdated)="stateUpdated($event)"
      (columnVisible)="adjustColumnSizes()"
      (toolPanelVisibleChanged)="adjustColumnSizes()"
      (cellClicked)="onCellClicked($event)"
    >
    </ag-grid-angular>
  }
</app-page>
